import React, { Suspense } from "react";
import { Environment, Preload, Stats } from "@react-three/drei";
import { Office } from "../Office";
import Screen from "../Screen/Screen";
import Holograms from "../Holograms/Holograms";
import { Lightformer } from "@react-three/drei";
import HologramInteractions from "../InteractionPoint/InteractionGroup/HologramInteractions";
import LdCenterInteractions from "../InteractionPoint/InteractionGroup/LdCenterInteractions";
import OptometryLabInteractions from "../InteractionPoint/InteractionGroup/OptometryLabInteractions";
import { Bloom, EffectComposer } from "@react-three/postprocessing";
import ServiceCenterInteractions from "../InteractionPoint/InteractionGroup/ServiceCenterInteractions";

export default function SceneManager() {
  // const rectLight = useRef();
  // useHelper(rectLight, RectAreaLightHelper, "hotpink");
  //
  // const positionA = useControls({
  //   x: { value: 0, min: -Math.PI, max: Math.PI, step: 0.01 },
  //   y: { value: 1.61, min: -Math.PI, max: Math.PI, step: 0.01 },
  //   z: { value: 0, min: -Math.PI, max: Math.PI, step: 0.01 },
  // });

  return (
    <group name={"scenes"}>
      {/*
      <Stats showPanel={0} className="stats" />
*/}

      <Suspense fallback={<></>}>
        <Preload all />
        <EffectComposer>
          <Bloom
            intensity={0.1} // The bloom intensity.
            luminanceThreshold={4} // luminance threshold. Raise this value to mask out darker elements in the scene.
            luminanceSmoothing={0.5} // smoothness of the luminance threshold. Range is [0, 1]
            mipmapBlur={true}
          />
        </EffectComposer>
        <Office />
        <Screen></Screen>
        <HologramInteractions></HologramInteractions>
        <LdCenterInteractions></LdCenterInteractions>
        <ServiceCenterInteractions></ServiceCenterInteractions>
        <OptometryLabInteractions></OptometryLabInteractions>
        <Holograms
          position={[-3.719, 1.493, 4.311]}
          scale={0.4}
          rotation={[0, Math.PI / 3, 0]}
        ></Holograms>
        <ambientLight intensity={1} />
        <rectAreaLight
          // ref={rectLight}
          width={4}
          height={0.5}
          color={"#0fffc7"}
          intensity={4}
          position={[-5.25, 1.85, 0.65]}
          rotation={[0, 1.61, 0]}
          // penumbra={5}
          power={24}
          castShadow
        />
        {/* <InternalParalax position={[0, 2, -8]}></InternalParalax> */}
        {/*<Sphere position={[0, 2, -3.8]} args={[1, 32, 32]}>*/}
        {/*  <HologramMaterial></HologramMaterial>*/}
        {/*</Sphere>*/}
      </Suspense>
      <Environment
        environmentIntensity={1.95}
        resolution={16}
        // files={[
        //   "cubeMap/px.png",
        //   "cubeMap/nx.png",
        //   "cubeMap/py.png",
        //   "cubeMap/ny.png",
        //   "cubeMap/pz.png",
        //   "cubeMap/nz.png",
        // ]}
        background={false}
      >
        <Lightformer
          color={"#f8ffff"}
          intensity={1.5}
          target={[0, 0.5, 0]}
          position={[0, -1.25, 0.5]}
          scale={[0.1, 10]}
          form="circle"
        />
        <Lightformer
          color={"#ffffff"}
          intensity={2.5}
          target={[0, 0.5, 0]}
          position={[0, 1, 0.1]}
          scale={[0.1, 10]}
          form="circle"
        />
        <Lightformer
          color={"#ffffff"}
          intensity={0.75}
          target={[0, 0.5, 0]}
          position={[0, 0, 1]}
          scale={[10, 1]}
          form="circle"
        />

        <Lightformer
          color={"#ccf7ff"}
          intensity={1}
          target={[0, 0, 0]}
          position={[-0.75, 0.5, -0.15]}
          scale={[2, 1.5]}
        />
        <Lightformer
          color={"#00b0ff"}
          intensity={2.5}
          target={[0, 0, 0]}
          position={[1.35, 0.75, 1.5]}
          scale={[1, 2.5]}
        />
      </Environment>
    </group>
  );
}
